import React, {useState, useCallback, Fragment} from "react";

function NewTextRadio({thingsList, onSelectThing, additionalClassName }) {

  const [selectedStats, setSelectedStats] = useState(thingsList[0]);
  const handleChangeItem = useCallback((thing, dropdownClick) => {
    setSelectedStats(thing);
    onSelectThing(thing);
  }, []);
  return (
    <div className={`text-radio-wrap ${additionalClassName}`}>
      {
        thingsList.map((thing, index) =>
          <Fragment key={index}>
            <button key={`text-radio-${index}-${thing.enumKey}`}
                    className={`text-radio-btn ${selectedStats === thing ? "clicked" : ""}`}
                    onClick={() => handleChangeItem(thing)}>
              {thing.name}
            </button>
            <i>·</i>
          </Fragment>
        )
      }
    </div>
  );
}

export default NewTextRadio;
